module.exports = __webpack_public_path__ + "static/media/media_recorder_for_ios.d299567c.pdf";